export default "__VITE_ASSET__DTmlR5LS__"